import { AxiosResponse } from "axios";
import axios from "./axios";
import { ENDPOINTS } from "./endpoints";

export const loginUser = async (email: string, password: string) => {
  try {
    console.log("Logging In...");
    let formData = new FormData();
    formData.append('email', email);
    formData.append('password', password);
    formData.append('app', 'quali-fi');

    const response = await axios.post(ENDPOINTS.LOGIN, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (!response) {
      throw new Error('Login failed');
    }
    sessionStorage.setItem('token', response.data.authorisation.token)
    sessionStorage.setItem('userId', response.data.user.Id);
    sessionStorage.setItem('email', response.data.user.EmailAddress);

    console.log("Successfully logged in");
  } catch (error) {
    console.log("Login Error!: ", error);
    throw error;
  }
};

export const isUserVirgin = async (email: string) => {
  try {
    let formData = new FormData();
    formData.append('email', email);

    const url: string = ENDPOINTS.CHECK_VIRGIN;
    const response: AxiosResponse = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (!response) {
      throw new Error('Check virgin status failed');
    }
    return response.data;
  } catch (error) {
    console.log("Check Virgin Error!: ", error);
  }
}

export const passwordReset = async (userId: number, password: string, confirmPassword: string) => {
  try {
    console.log("Resetting Password...");
    let formData = new FormData();
    formData.append('id', String(userId));
    formData.append('password', password);
    formData.append('password2', confirmPassword);

    const response = await axios.post(ENDPOINTS.PASSWORD_RESET, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    if (!response) {
      throw new Error('Password reset failed');
    }
    console.log("Password reset successfully");
  } catch (error) {
    console.log("Password Reset Error!: ", error);
  }
}

// Unused as of now
export const logoutUser = async () => {
  try {
    console.log("Logging Out...");
    const response = await axios.post(ENDPOINTS.LOGOUT);

    if (!response) {
      throw new Error('Logout failed');
    }
    sessionStorage.clear();
    console.log("Successfully logged out");
  } catch (error) {
    console.log("Logout Error!: ", error);
    throw error;
  }
};